export default {
    loading: state => state.app.loading,
    user: state => state.auth && state.auth.user,
    token: state => state.auth && state.auth.token,
    companies: state => state.auth && state.auth.user.empresas,
    companiesFlat: state =>
        state.auth &&
        state.auth.user.empresas.map(company => company.pessoa.nomeFantasia),
    companySelected: state => state.app.companySelected
};
